import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74f2ffb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taskcard-action-form d-flex flex-column gap-2" }
const _hoisted_2 = { class: "taskcard-action-form__title m-0 mb-0 fw-bold" }
const _hoisted_3 = { class: "labelled-select rounded-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Board", -1))
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = { class: "labelled-select rounded-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "List", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "List", -1))
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"labelled-select rounded-2 w-75\" data-v-74f2ffb4><span class=\"label\" data-v-74f2ffb4>Position</span><select disabled class=\"form-select border-0 shadow-none\" aria-label=\"select position\" data-v-74f2ffb4><span class=\"label\" data-v-74f2ffb4>Position</span><option value=\"1\" selected data-v-74f2ffb4>Position #1</option><option value=\"2\" data-v-74f2ffb4>Position #2</option><option value=\"3\" data-v-74f2ffb4>Position #3</option></select></div>", 1)
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("select", {
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBoardChange && _ctx.handleBoardChange(...args))),
        class: "board form-select border-0 shadow-none",
        "aria-label": "select board"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBoards, (board) => {
          return (_openBlock(), _createElementBlock("option", {
            key: board._id,
            value: board._id,
            selected: board._id === _ctx.$route.params.boardId
          }, _toDisplayString(board.name), 9, _hoisted_5))
        }), 128))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("select", {
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleListChange && _ctx.handleListChange(...args))),
          class: "form-select list border-0 shadow-none",
          "aria-label": "select list"
        }, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedBoard.lists, (boardList) => {
            return (_openBlock(), _createElementBlock("option", {
              key: boardList._id,
              value: boardList._id,
              selected: boardList._id === _ctx.list._id
            }, _toDisplayString(boardList.name), 9, _hoisted_10))
          }), 128))
        ], 32)
      ]),
      _hoisted_11
    ]),
    _createElementVNode("button", {
      disabled: _ctx.disable,
      type: "submit",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('submit', _ctx.form)), ["prevent"])),
      class: "taskcard-action-form__submit btn-primary-1"
    }, _toDisplayString(_ctx.submitText), 9, _hoisted_12)
  ]))
}